import {Component, Injector} from '@angular/core';
import {NewsletterState, Store as NewsletterStore} from './state/store';
import {Newsletter} from './state/model';
import {NewsletterService as NewsletterService} from './state/service';
import {EntityDetailComponent} from '../../components/entity-detail/component';
import {FormBuilder} from '@angular/forms';
import {NewsletterQuery} from './state/query';

@Component({
  templateUrl: '../../components/entity-detail/component.html',
  styleUrls: ['../../components/entity-detail/component.scss']
})
export class NewsletterDetailComponent extends EntityDetailComponent<Newsletter, NewsletterState, NewsletterStore> {

  constructor(
    public injector: Injector,
    service: NewsletterService,
    protected query: NewsletterQuery,
    protected formBuilder: FormBuilder) {
    super(injector, service, query);
  }
}
